import React, { useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import { Box, Button, IconButton, MenuItem, Select, TextField, Typography } from '@mui/material';
import { v4 as uuid } from 'uuid';

import { getStyles } from './styles';
import { IconSvg } from '../../../../../utils/globalIcons';
import { ReactSVG } from 'react-svg';
import GeneralTable from '../../../../../components/GeneralTable';

function Links({ linksData, setLinksData }) {
    const theme = useTheme();
    const styles = getStyles(theme);

    const handleAddTempUrl = () => {
        if ((linksData.tempUrl || "").trim() === "") return;
        setLinksData({
            ...linksData,
            pendingUrls: [...linksData.pendingUrls, { url: linksData.tempUrl }],
            tempUrl: ""
        });
    };

    const handleRemoveTempUrl = (index) => {
        setLinksData({
            ...linksData,
            pendingUrls: (linksData.pendingUrls || []).filter((_, i) => i !== index)
        });
    };

    const handleSave = () => {
        const newRows = (linksData.pendingUrls || []).map((item) => ({
            id: uuid(),
            url: item.url,
            status: "Processing",
            created_at: new Date().toISOString(),
            auto_sync: "off"
        }));
        setLinksData({ ...linksData, links: [...linksData.links, ...newRows], pendingUrls: [] });
    };

    const handleRemoveUrl = (url) => {
        try {
            const updatedLinks = (linksData.links || [])?.filter(item => item.id != url.id)
            setLinksData({ ...linksData, links: updatedLinks });
        } catch (error) {
            console.log(error)
        }

    }

    const progressStatus = {
        Processing: "Training",
        Failed: "Failed",
        Success: "Trained",
    }

    const columns = [
        {
            id: 'url',
            label: 'URL',
            sortable: true,
            renderCell: (row) => row?.url
        },
        {
            id: 'status',
            label: 'Training Status',
            sortable: true,
            renderCell: (row) => (
                <Box display={'flex'} alignItems={'center'}>
                    <ReactSVG
                        src={{
                            Processing: IconSvg.trainingIcon,
                            Success: IconSvg.trainedIcon,
                            Failed: IconSvg.errorIcon
                        }[row?.status]}
                        beforeInjection={(svg) => {
                            svg.setAttribute('style', 'width:24px; height:24px; display:block;');
                        }}
                    />
                    <Typography sx={{ fontSize: '14px', fontWeight: 400, textTransform: 'none', marginLeft: '10px' }}>
                        {progressStatus[row?.status] || row?.status}
                    </Typography>
                </Box>
            )
        },
        // {
        //     id: 'last_synched',
        //     label: 'Last Synced On',
        //     sortable: true,
        //     renderCell: (row) => row?.created_at?.substring(0, 10)
        // },
        // {
        //     id: 'auto_sync',
        //     label: 'Auto Sync',
        //     sortable: true,
        //     renderCell: (row, rowIndex) => (
        //         <Select
        //             size="small"
        //             value={row.auto_sync || "off"}
        //             sx={{ width: '150px' }}
        //             onChange={(e) => {
        //                 const newData = [...linksData];
        //                 newData[rowIndex].auto_sync = e.target.value;
        //                 setLinksData({ ...linksData, links: newData });
        //             }}
        //         >
        //             <MenuItem value="off">Off</MenuItem>
        //             <MenuItem value="weekly">Weekly</MenuItem>
        //             <MenuItem value="monthly">Monthly</MenuItem>
        //             <MenuItem value="yearly">Yearly</MenuItem>
        //         </Select>
        //     )
        // },
        // {
        //     id: '',
        //     label: '',
        //     sortable: true,
        //     renderCell: (row) => (<Box>
        //         <Typography sx={{ fontSize: '14px', fontWeight: 400, color: '#0B51C5', '&:hover': { textDecoration: 'underline' } }}>
        //             Sync now
        //         </Typography>
        //     </Box>)
        // },
        {
            id: '',
            label: '',
            sortable: true,
            renderCell: (row) => (<IconButton
                onClick={() => handleRemoveUrl(row)}
            >
                <ReactSVG
                    src={IconSvg.deleteIcon}
                    beforeInjection={(svg) => {
                        svg.setAttribute('style', 'width:20px; height:20px; display:block;');
                        svg.setAttribute('stroke', '#C30E2E');
                    }}
                />
            </IconButton>)
        }
    ];

    return (
        <Box>

            {linksData.errorStatus &&
                (<Typography sx={{ fontSize: '14px', fontWeight: '400', color: "#C30E2E", marginBottom: '10px' }}>
                    {linksData.errorMessage}
                </Typography>)
            }

            <Typography sx={{ fontSize: "14px", fontWeight: "400" }}>Website URL</Typography>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '8px' }}>
                <TextField
                    variant="outlined"
                    placeholder='URL'
                    type="text"
                    size='small'
                    sx={{ width: '500px' }}
                    value={linksData.tempUrl}
                    onChange={(e) => setLinksData({ ...linksData, tempUrl: e.target.value })}
                />
                <IconButton onClick={handleAddTempUrl}>
                    <ReactSVG
                        src={IconSvg.addIcon}
                        beforeInjection={(svg) => {
                            svg.setAttribute('style', 'width:24px; height:24px; display:block;');
                            svg.setAttribute('stroke', '#0B51C5');
                        }}
                    />
                </IconButton>
            </Box>

            {(linksData.pendingUrls || []).map((item, index) => (
                <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '10px' }}>
                    <TextField
                        variant="outlined"
                        type="text"
                        size='small'
                        sx={{ width: '500px' }}
                        value={item.url}
                        disabled
                    />
                    <IconButton onClick={() => handleRemoveTempUrl(index)}>
                        <ReactSVG
                            src={IconSvg.deleteIcon}
                            beforeInjection={(svg) => {
                                svg.setAttribute('style', 'width:24px; height:24px; display:block;');
                                svg.setAttribute('stroke', '#C30E2E');
                            }}
                        />
                    </IconButton>
                </Box>
            ))}

            {(linksData.pendingUrls || []).length > 0 && (
                <Box marginTop={'10px'}>
                    <Button
                        sx={{ ...styles.uploadBtn, width: '150px' }}
                        onClick={handleSave}
                    >
                        <Typography style={styles.btnText}>Add and Train</Typography>
                    </Button>
                </Box>
            )}

            <Box marginTop={'30px'} width={'780px'}>
                <GeneralTable
                    data={linksData.links || []}
                    columns={columns}
                    loading={linksData.loading}
                />
            </Box>

            <Box sx={{ border: '1px solid #D9D9D9', borderRadius: '5px', padding: '20px', marginTop: '30px', width: '780px' }}>
                <Typography marginBottom={'4px'}>Auto Sync <span style={{ color: 'red' }}>*</span></Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'row', gap: '20px' }}>
                    <Select
                        size="small"
                        value={linksData.importInterval || "one_hour"}
                        sx={{ width: '150px' }}
                        onChange={(e) => setLinksData({ ...linksData, importInterval: e.target.value })}
                    >
                        <MenuItem value="one_hour">1 Hour</MenuItem>
                        <MenuItem value="two_hour">2 Hours</MenuItem>
                        <MenuItem value="three_hour">3 Hours</MenuItem>
                        <MenuItem value="four_hour">4 Hours</MenuItem>
                        <MenuItem value="five_hour">5 Hours</MenuItem>
                        <MenuItem value="six_hour">6 Hours</MenuItem>
                    </Select>

                    {/* <Button
                        variant='text'
                        disableRipple
                        sx={{
                            all: 'unset', display: 'flex', alignItems: 'center',
                            justifyContent: 'center', cursor: 'pointer'
                        }}
                        onClick={() => setLinksData(prev => ({ ...prev, syncNow: !prev.syncNow }))}
                    >
                        <Typography sx={{ fontSize: '14px', fontWeight: '400', color: '#0B51C5', "&:hover": { textDecoration: 'underline' } }}>
                            {linksData?.syncNow ? "Syncing" : "Sync now"}
                        </Typography>
                    </Button> */}

                </Box>

            </Box>
        </Box >
    )
}

export default Links;
